/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewsubtitle2Inputs */

const en_sharereviewsubtitle2 = /** @type {(inputs: Sharereviewsubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Held visits from shared links and the businesses earning the most cashback this month. Approved steps are credited on the next hourly run, within the monthly limit and while the offer runs.`)
};

const de_sharereviewsubtitle2 = /** @type {(inputs: Sharereviewsubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückgehaltene Besuche aus geteilten Links und die Unternehmen mit dem meisten Cashback in diesem Monat. Freigegebenes wird beim nächsten stündlichen Lauf gutgeschrieben, innerhalb der Monatsgrenze und solange die Aktion läuft.`)
};

/**
* | output |
* | --- |
* | "Held visits from shared links and the businesses earning the most cashback this month. Approved steps are credited on the next hourly run, within the monthly..." |
*
* @param {Sharereviewsubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewsubtitle2 = /** @type {((inputs?: Sharereviewsubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewsubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewsubtitle2(inputs)
	return de_sharereviewsubtitle2(inputs)
});
export { sharereviewsubtitle2 as "shareReviewSubtitle" }